module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/video-red-482774ced030944704307168afd01775.svg";